import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useBotRunStreams from '../../hooks/useBotRunStreams';
import ApprovalCard from './ApprovalCard';
import BotAvatar from './BotAvatar';
import { useBotLabel } from './botDisplay';
import { activityLabel } from './botActivity';

/** Bots answering an @mention on this task: what they are doing, or what they need you to approve. */
const BotReplying = ({ status, bots }) => {
  const botLabel = useBotLabel();
  const { t } = useTranslation();
  const replying = useMemo(() => status?.replying || [], [status]);
  const live = useBotRunStreams(replying);
  if (replying.length === 0) return null;
  return (
    <div className="space-y-2 mb-4" data-testid="bot-replying">
      {replying.map((r) => {
        const bot = bots.find((b) => b.id === r.bot_id);
        const name = bot ? botLabel(bot) : t('bots.bot_badge');
        if (r.status === 'waiting_approval') {
          return (status.approvals || []).filter((a) => a.run_id === r.id).map((a) => (
            <ApprovalCard key={a.id} approval={a} botName={name} />
          ));
        }
        return (
          <div key={r.id} className="flex items-center gap-3 text-sm text-muted-foreground">
            {/* The bee buzzes while the bot works (after Grok Bot: no typing dots). */}
            <BotAvatar bot={bot} size={32} state="working" />
            <span className="truncate">{t('bots.control.replying', { bot: name })}: {activityLabel(t, live[r.id])}</span>
          </div>
        );
      })}
    </div>
  );
};

export default BotReplying;
